import script from "./insurance-form-confirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-form-confirm.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-form-confirm.vue?vue&type=style&index=0&id=e3af6068&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3af6068"]])

export default __exports__